module.exports = __webpack_public_path__ + "static/media/dataWallet.deaec3f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/dataWallet.png
// module id = 1832
// module chunks = 146